import React from 'react'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import { createBrowserHistory } from 'history'

import Discontinue from './pages/discontinue'

import './styles/app.scss'
import './styles/onmail.scss'
import './components/footer/footer.scss'

const history = createBrowserHistory()

export default function Deprecation() {
  return (
    <Router history={history}>
      <div>
        <Switch>
          <Route exact path="/" component={Discontinue} />
          <Redirect from="/*" to="/" />
        </Switch>
        <Footer />
      </div>
    </Router>
  )
}

function Footer() {
  function onPrivacyClick(event) {
    event.preventDefault()
    document.getElementById('clarip-do-not-sell-link').click()
  }
  return (
    <div
      className="onmail-footer background-onmail-black"
      style={{ paddingTop: 100, paddingBottom: 100 }}
    >
      <div className="max-width-container center-for-small">
        <p className="padding-bottom-small right-text" onClick={onPrivacyClick}>
          <a>
            <span
              id="clarip-do-not-sell-link"
              style={{ display: 'inline-flex' }}
            >
              <span>Your Privacy Choices</span>
              <img
                alt="privacy-options"
                style={{ width: '40px', marginLeft: '10px' }}
                src="https://oag.ca.gov/sites/all/files/agweb/images/privacy/privacyoptions.svg"
              />
            </span>
          </a>
        </p>

        <div className="row">
          <div
            className="small-12 medium-4 large-5"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <img
              alt="OnMail company logo"
              className="onmail-footer-logo"
              src="/images/onmail-logo-grey.png"
            />
          </div>
          <div className="small-12 medium-8 large-7 right-text onmail-white mobile-co-padding">
            <p className="subheading" style={{ fontSize: '.75em' }}>
              &copy; {new Date().getFullYear()} Edison Software
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
